import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AppRedirectService } from '../../services/app-redirect.service';
import { TranslationService } from '../../services/translation.service';


@Component({
    selector: 'app-smart-app-banner',
    templateUrl: './smart-app-banner.component.html',
    styleUrls: ['./smart-app-banner.component.scss'],
    imports:   [TranslateModule, AsyncPipe],
    standalone: true
})
export class SmartAppBannerComponent implements OnInit {
  translationData: any;
  showSpinner$!: Observable<boolean>;
  openAppUrl: string = '';

  constructor(private readonly translationService: TranslationService,
    private readonly appRedirectService: AppRedirectService) {
     }

  isShowSpinner: boolean = false;

  ngOnInit(): void {
    this.translationService.fetchConfigDetails().subscribe((config: any) => {
      this.translationService.cpConfig = config;
      this.openAppUrl = this.appRedirectService.getOpenAppUrl();
    });
  }

  // The anchor's href performs the real link-activated navigation — iOS opens
  // the app via the universal link. JS only arms the store fallback.
  onOpenInAppTap() {
    this.showSpinner$ = this.appRedirectService.showSpinner$;
    setTimeout(() => {
      this.appRedirectService.closeSpinner();
      this.showSpinner$ = this.appRedirectService.showSpinner$;
    }, 3000);
    this.appRedirectService.watchOpenAppAttempt();
  }

   triggerGoToApp() {
    this.showSpinner$ = this.appRedirectService.showSpinner$;
    setTimeout(()=>{
      this.appRedirectService.closeSpinner();
      this.showSpinner$ = this.appRedirectService.showSpinner$;
    }, 3000);
    this.appRedirectService.triggerGoToApp();
  }

  takeToGooglePlayStore() {
          this.appRedirectService.getSmartBannerLinks();

    const playStoreLink = this.appRedirectService.appStoreLink
    window.open(playStoreLink, '_blank')
   }

   takeToAppleStore() {
          this.appRedirectService.getSmartBannerLinks();

    const appleStoreLink = this.appRedirectService.playStoreLink;
    window.open(appleStoreLink, '_blank')
   }


}
